import { ChannelUnsubscribe, channelClient, RequestPolicy } from 'shared/channels';
import { DomainMessagesTypes } from 'shared/domain/messages/message';
import { logoutContract } from './logoutContract';

/**
 * Signing out must not keep the user waiting: past the timeout the page goes
 * on and the worker finishes flushing on its own, so the timeout is expected.
 */
const LOGOUT_POLICY: RequestPolicy = { timeoutMs: 5_000, retryAfterTimeout: false, timeoutIsExpected: true };

/** Signing out in the worker, and hearing of it in every tab. */
export const logoutClient = {
  /** Resolves once the worker dropped the user's data. */
  logOut(): Promise<void> {
    return channelClient.request(logoutContract, 'logout', undefined, LOGOUT_POLICY);
  },

  onLoggedOut(handler: () => void): ChannelUnsubscribe {
    return channelClient.onEventOfType(logoutContract, DomainMessagesTypes.logout, () => handler());
  },
};
